import { motion } from "framer-motion"
import { Link } from "react-router-dom"

function HeroSection() {
  return (
    <div className="relative h-screen flex items-center justify-center">
      {/* Imagen de fondo */}
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1505664194779-8beaceb93744?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
        }}
      />

      {/* Overlay oscuro para mejorar la legibilidad del texto */}
      <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

      {/* Contenido */}
      <div className="relative z-20 text-white text-center px-4">
        <motion.h1
          className="text-4xl md:text-6xl font-bold mb-4"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Encuentra el Bufete de Abogados Ideal
        </motion.h1>
        <motion.p
          className="text-xl mb-8 max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          Conectamos clientes con los mejores bufetes de abogados. Regístrate hoy y obtén asesoría legal de calidad.
        </motion.p>
        <motion.div
          className="space-x-4"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <Link
            to="/registro-cliente"
            className="bg-[var(--gold)] text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 hover:text-[var(--gold)] transition duration-300"
          >
            Soy Cliente
          </Link>
          <Link
            to="/registro-bufete"
            className="bg-transparent border-2 border-[var(--gold)] text-[var(--gold)] px-6 py-3 rounded-lg font-semibold hover:bg-white hover:text-[var(--gold)] hover:border-white transition duration-300"
          >
            Soy Bufete
          </Link>
        </motion.div>
      </div>

      {/* Flecha de desplazamiento */}
      <motion.div
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.5, repeat: Number.POSITIVE_INFINITY, repeatType: "reverse" }}
      >
        <svg
          className="w-6 h-6 text-white"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </motion.div>
    </div>
  )
}

export default HeroSection

